import axios from 'axios';
import dayjs from 'dayjs'
// 사용자 정의 모듈.
import * as config from './config';
import store from './store';

var common = {
    setParams(data){
        store.commit('setParams', {
            value : data
        });
    },
    getParams(){
        return store.getters['getParams'].value
    },
    // geoLocation 위치정보 얻기
    getLocation(callback){
        if (navigator.geolocation) { // GPS를 지원하면
            navigator.geolocation.getCurrentPosition(function(position) {
                callback(position.coords);
            }, function(error) {
                console.error(error);
            }, {
                enableHighAccuracy: true,
                maximumAge: 3000,
                timeout: 5000
            });
        } else {
            alert('GPS를 지원하지 않습니다');
        }
    },
    // 서버에서 데이터 가져오기(단일)
    getData(type, data, callback){
        store.dispatch(type.action_name, {
            type: type,
            data: data
        }).then((response) => {
            // this.store_list = response;
            store.commit('setLoading', { value: false});
            callback(response);
        }).catch(function (error) {
            console.log('error=============>', error);
        });
    },
    // 서버에서 데이터 가져오기(복수)
    getDataList(types, datas, callback){
        var type_array = [];
        for(var idx=0; idx<types.length; idx++){
            var arr = store.dispatch(types[idx].action_name, {
                            type: types[idx],
                            data: datas
                        })
            type_array.push(arr);
        }
        Promise.all(type_array).then(responseList => {
            store.commit('setLoading', { value: false});
            callback(responseList);
        }).catch(function (error) {
            console.log('error=============>', error);
        });;
    },
    setLocationData(callback){
        store.commit('setLoading', { value: true});
        if(this.cmmnGetConnectDevice().device_type == 'pc'){
            this.getLocation((result, error) =>{
                if(error){
                    console.log('get GeoLocation Error: ', error);
                }else{
                    var data = {'my_lat': result.latitude, 'my_lon': result.longitude};
                    store.commit('setLocation', {
                        value: data
                    });
                    callback(data);
                }
            })
        }else if(this.cmmnGetConnectDevice().device_type == 'mobile'){
            var locationCallback = function(command, result){
                // console.log('GPS 위치 정보 : ', JSON.stringify(result));
                var data = {'my_lat': result.latitude, 'my_lon': result.longitude};
                store.commit('setLocation', {
                    value: data
                });
                callback(data);
            };
            this.getMobileLocation(locationCallback);
            
        }
    },
    // IOS/안드로이드 여부 확인 [iosYn: true - IOS, iosYn: false - Android]  
    getMobileDevice(){
        var iosYn = false;
        var varUA = navigator.userAgent.toLowerCase();
        if (varUA.indexOf("iphone")>-1||varUA.indexOf("ipad")>-1||varUA.indexOf("ipod")>-1) {
            iosYn = true;
        }
        return iosYn;
    },
    getMobileLocation(locationCallback){
        window.locationCallbackFunc = locationCallback;
        // IOS일 경우
        if(this.getMobileDevice()){
            window.webkit.messageHandlers.reqIosLocationInfo.postMessage('getLocationInfo');
        // 안드로이드일 경우
        }else {
            // window.locationCallbackFunc = locationCallback;
            window.promotion.reqAndroidLocationInfo();
        }
    },
    goKioskMobile(data){        	
        // IOS일 경우	
        if(this.getMobileDevice()){	
            window.webkit.messageHandlers.goIosKioskMobile.postMessage(data);	
        // 안드로이드일 경우	
        }else {	
            window.promotion.goAndroidKioskMobile(data);	
        }
        window.open(config.KIOSK_HOST + "?t=" + dayjs().format('YYYYMMDDHHmm') ,'kiosk');
    },
    // 코드 추가 - 2020-12-21
    goKakaoChannel(kakao_link){
        window.promotion.goKakaoChannel();
        window.open(kakao_link, 'kakao');
    },
    // 자동 로그인 확인
    autoLoginCheck(autoLoginCheckCallback){
        window.autoLoginCheckCallbackFunc = autoLoginCheckCallback;
        // IOS일 경우
        if(this.getMobileDevice()){
            window.webkit.messageHandlers.autoLoginCheck.postMessage('token');
        // 안드로이드일 경우
        }else {
            window.promotion.autoLoginCheck();
        }
    },
    // 자동 로그인 설정
    autoLoginSetting(token){
        // IOS일 경우
        if(this.getMobileDevice()){
            window.webkit.messageHandlers.autoLoginSetting.postMessage(token);
        // 안드로이드일 경우
        }else {
            window.promotion.autoLoginSetting(token);
        }
    },
    // 자동 로그인 설정 삭제
    removeAutoLoginSetting(){
        // IOS일 경우
        if(this.getMobileDevice()){
            window.webkit.messageHandlers.removeAutoLoginSetting.postMessage('token');
        // 안드로이드일 경우
        }else {
            window.promotion.removeAutoLoginSetting();
        }
    },
    // 장치 확인
    cmmnGetConnectDevice(){
        var filter = "win16|win32|win64|mac";
        var device_type = "pc";
        var varUA = navigator.userAgent.toLowerCase();
        var result = {};
        var phone = '';
        if(navigator.platform){
            if(0 > filter.indexOf(navigator.platform.toLowerCase())){
                device_type = "mobile";

                if(this.getMobileDevice()){
                    phone = 'ios';
                }else{
                    phone = 'android';
                }
            }
        }
        result.device_type = device_type;
        result.phone = phone;
        return result;
    },
    // 금액 3자리에 마다 콤마 생성
    setNumberComma(num){
        var reg = /(^[+-]?\d+)(\d{3})/;
        num += '';
        while (reg.test(num)) {
            num = n.replace(reg, '$1' + ',' + '$2');
        }         
        return num;
    },
    // 특수 문자 제거
    removeSpe(str){
        var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
        
        if(regExp.test(str)){
            var t = str.replace(regExp, "");
            str = t;
        }

        return str;
    }


}

export default common


// WEBPACK FOOTER //
// ./src/js/common.js